import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faUser } from '@fortawesome/free-regular-svg-icons';
import { COMMUNITY, DASHBOARD, EVENTS, NEWNOTE, PROFILE, SETTINGS, STORE, TREEPILOTMENTOR } from 'lib/routes';
import React, { useContext, useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { faBook, faSeedling, faPlusCircle, faClose, faBars, faGear, faStore } from '@fortawesome/free-solid-svg-icons';
// import { ReactComponent as mentorIcon } from 'imgs/TreePilotMentor.svg'
import { Icon } from '@iconify/react';
import 'stylesheets/MainAppStyles/navBar.css'
import TreePilotMentorIcon from 'imgs/treePilotMentorIcon'
import treePilotLogo from 'imgs/logobn.png'
import treepointsIcon from 'imgs/treepoints.png'

import { PageContext } from 'contexts/TimerAppContexts/PageContext';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { useAuth } from 'hooks/auth';
import { Avatar } from '@chakra-ui/react';
import SpinnerLoading from '../Spiners';

const Navbar = () => {
    // const { item, loading, error, saveItem } = useLocalStorage('CurrentPage', 'timecontrol')
    const { currentPage, setCurrentPage } = useContext(PageContext);
    const [openNav, setOpenNav] = useState(false);
    const { user, isLoading } = useAuth();
    const [points, setPoints] = useState(0);
    const handleChangePage = (page) => {
        setCurrentPage(page)
        handleOpenNav()
        if (page === 'notes') {
            const body = document.querySelector('body')
            body.style.overflowY = 'auto'
        }
    }
    const handleOpenNav = () => {
        const body = document.querySelector('body')
        if (openNav === false) {
            body.style.overflowY = 'hidden'
        } else {
            body.style.overflowY = 'unset'
        }
        setOpenNav(!openNav)
    }

    useEffect(() => {
        const body = document.querySelector('body')
        const handleWindowResize = () => {

            if (window.innerWidth < 870) {
                const nav = document.querySelector('.nav-bar-container-section')
                nav.classList.remove('open')
                nav.classList.add('close')
            } else {
                const nav = document.querySelector('.nav-bar-container-section')
                nav.classList.remove('open')
                nav.classList.add('close')
                body.style.overflowY = 'auto'
            };
        }
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []
    );

    useEffect(() => {
        setCurrentPage(window.location.pathname.split('/')[2])

    }, [currentPage])

    // function ActiveUser() {
    //     const { user, isLoading } = useAuth();
    //     if (isLoading) return <SpinnerLoading />
    //     return (
    //         <>
    //             <Avatar size="md" src={user?.avatar} />
    //             <div className="current-user-info">
    //                 <h1 className='name'>{user.name} {user.lastname}</h1>
    //                 <h2 className='username'>@{user.username}</h2>
    //             </div>
    //         </>
    //     )
    // }
    useEffect(() => {
        setPoints(user?.treepoints)
    }, [user])

    return (
        <>
            <div className={`nav-bar-container-section ${openNav ? 'open' : 'close'}`}>
                <div className="nav-bar-container">
                    <Link onClick={() => { handleChangePage('timecontrol') }} className={`nav-bar-item ${currentPage === 'timecontrol' ? 'selected' : ''}`} to={DASHBOARD}><Icon className='icon' icon='ant-design:home-filled'/></Link>
                    <Link onClick={() => { handleChangePage('notes') }} className={`nav-bar-item ${currentPage === 'notes' ? 'selected' : ''}`} to={COMMUNITY}><Icon className='icon' icon='solar:notes-bold-duotone'/></Link>
                    <Link onClick={() => { handleChangePage('treepilotmentor') }} className={`nav-bar-item ${currentPage === 'treepilotmentor' ? 'selected' : ''}`} to={TREEPILOTMENTOR}><TreePilotMentorIcon className="mentor-icon icon" /></Link>
                    {/* <Link onClick={() => { handleChangePage('profile') }} className={`nav-bar-item ${currentPage === 'profile' ? 'selected' : ''}`} to={PROFILE}><FontAwesomeIcon className='icon' icon={faUser} /></Link> */}
                    <Link onClick={() => { handleChangePage('events') }} className={`nav-bar-item ${currentPage === 'events' ? 'selected' : ''}`} to={EVENTS}><Icon className='icon' icon='mdi:events'/></Link>
                    <Link onClick={() => { handleChangePage('store') }} className={`nav-bar-item ${currentPage === 'store' ? 'selected' : ''}`} to={STORE}><Icon className='icon' icon='clarity:store-solid'/></Link>
                    <Link onClick={() => { handleChangePage('settings') }} className={`nav-bar-item ${currentPage === 'settings' ? 'selected' : ''}`} to={SETTINGS}><Icon className='icon' icon='mdi:gear-outline'/></Link>
                </div>
            </div>
            <div className='nav-bar-main-container'>
                <FontAwesomeIcon onClick={handleOpenNav} className='openNav' icon={faBars} />

            </div>
        </>

    )
}

export default Navbar